import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import WhatsAppButton from "@/components/common/WhatsAppButton";
import { Reveal } from "@/components/common/Reveal";

// The recurring "How Can We Help You?" conversion band.
export default function HelpCTA({
  eyebrow = "How Can We Help You?",
  title = "Tell us what you're trying to achieve. We'll help you find the right solution.",
  body = "Athena Scientific listens, understand your requirements and helps identify the best solution. Whether you're setting up a new laboratory, replacing an existing instrument, improving a workflow or exploring a new application, start by telling us what you need to achieve.",
  primaryLabel = "Talk to Our Team",
  primaryTo = "/contact",
  secondaryLabel = "Send an Enquiry",
  secondaryTo = "/enquiry",
  waMessage,
  variant = "aqua",
}) {
  const dark = variant === "dark";

  return (
    <section className={`${dark ? "bg-ink text-white noise" : "bg-aqua text-white"}`} data-testid="help-cta">
      <div className="container-x py-20 md:py-28">
        <Reveal>
          <p className={`eyebrow ${dark ? "text-white/70" : "text-white/80"} before:bg-white`}>{eyebrow}</p>
          <div className="mt-6 grid md:grid-cols-12 gap-8 items-end">
            <h2 className="md:col-span-7 text-3xl md:text-5xl font-bold leading-[1.05] tracking-tight text-balance">
              {title}
            </h2>
            <div className="md:col-span-5">
              <p className={`${dark ? "text-white/70" : "text-white/90"} text-lg`}>{body}</p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to={primaryTo}
                  data-testid="helpcta-primary"
                  className={`inline-flex items-center gap-2 px-6 py-3.5 rounded-md font-semibold transition-all ${dark ? "bg-aqua text-white hover:bg-aqua-dark" : "bg-ink text-white hover:bg-black"}`}
                >
                  {primaryLabel} <ArrowRight className="w-4 h-4" />
                </Link>
                <Link
                  to={secondaryTo}
                  data-testid="helpcta-secondary"
                  className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md font-semibold bg-white/15 backdrop-blur border border-white/30 text-white hover:bg-white hover:text-ink transition-all"
                >
                  {secondaryLabel}
                </Link>
                {/* No default message passed on purpose: without one the button
                    offers the CMS preset questions instead of jumping straight
                    into an empty chat. */}
                <WhatsAppButton message={waMessage} variant="solid" testId="helpcta-whatsapp" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
